import { Skeleton } from '../Skeleton';

interface ListPageSkeletonProps {
  rows?: number;
  withTabs?: boolean;
}

export function ListPageSkeleton({ rows = 4, withTabs = true }: ListPageSkeletonProps) {
  return (
    <div className="space-y-6">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div className="space-y-2">
          <Skeleton className="h-7 w-48" />
          <Skeleton className="h-4 w-64" />
        </div>
        <div className="flex gap-2">
          <Skeleton className="h-10 w-36" />
          <Skeleton className="h-10 w-36" />
        </div>
      </div>

      {withTabs && (
        <div className="border-b border-gray-200">
          <div className="flex gap-8 pb-2">
            {[0, 1, 2].map((i) => (
              <Skeleton key={i} className="h-5 w-20" />
            ))}
          </div>
        </div>
      )}

      <div className="space-y-3">
        {Array.from({ length: rows }).map((_, i) => (
          <div
            key={i}
            className="bg-white rounded-xl border border-gray-200 p-4 flex items-center gap-4"
          >
            <Skeleton className="h-12 w-12 flex-shrink-0" />
            <div className="flex-1 space-y-2">
              <Skeleton className="h-4 w-3/4" />
              <Skeleton className="h-3 w-1/2" />
            </div>
            <Skeleton className="h-8 w-20 flex-shrink-0" />
          </div>
        ))}
      </div>
    </div>
  );
}
